/**
 * Whether an agent account is blocked by admin.
 * API `user_status`: 1 / true = active (unblocked), 0 / false = blocked.
 * Matches users page — tooltip "Block Agent" when user_status is truthy (active).
 */
export const isAgentAccountBlocked = (user) => {
  if (!user) return false;
  const status = user.user_status;
  if (status === false || status === 0 || status === "0") return true;
  return false;
};
